/**
 * Animate scroll to target
 *
 * @param {String} selector - CSS selector
 * @param {Number} offset - Offset of target position
 * @param {Number} speed - Scroll speed in ms
 */
export default function ScrollAnimation (selector, offset = 0, speed = 500) {
    return new Promise(resolve => {
        let
            animationFrame,
            currentFrame = 0
        const
            frames = (speed / 1000) * 60,
            startPosition = window.scrollY || window.pageYOffset

        /**
         * Easing function
         * @see https://gist.github.com/gre/1650294
         *
         * @param {Number} t - Progress [0, 1] => [0, 1]
         */
        function easeInOutQuad (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t }
        /**
         * Stop the animation as soon as the user is scrolling
         */
        function stopAnimation () {
            if (animationFrame) {
                window.cancelAnimationFrame(animationFrame)
            }
            resolve()
        }
        window.addEventListener('mousewheel', stopAnimation)
        window.addEventListener('touchstart', stopAnimation)

        let target
        let elPosition = -window.scrollY

        if (selector !== '#top') {
            target = document.querySelector(selector)
            if (!target) {
                console.warn(`Element ${ selector } not found!`)
                return
            }
            elPosition = target.getBoundingClientRect().top
        }

        /**
         * Recursively run animation until last frame is reached
         */
        function runAnimation () {
            animationFrame = window.requestAnimationFrame(() => {
                const
                    progress = currentFrame / frames,
                    easing = easeInOutQuad(progress)
                window.scrollTo(0, easing * (elPosition - offset) + startPosition)
                currentFrame += 1
                if (currentFrame <= frames) {
                    runAnimation()
                } else {
                    resolve()
                }
            })
        }

        runAnimation()
    })
}
